import { yearDateFormat } from '@constants/dateFormat';
import { HiringRequest } from '@interfaces/open-positions.model';
import { formatSingleDate } from '@utils/utils';

export function mapResponse(hiringRequest: HiringRequest) {
  const panels = hiringRequest.hiringRequestDto?.hiringPanels ?? [];
  const panelName = (n: number): string | null =>
        panels.find((p) => Number(p.panelNumber) === n)?.employeeName ?? null;

  return {
    primarySkills: hiringRequest?.skillName?.toString(),
    hiringRequestId: hiringRequest.hiringRequestDto?.hiringRequestId ?? null,
    numberOfPositions: hiringRequest.hiringRequestDto?.numberOfPositions ?? 0,
    yearsOfExperience: hiringRequest.hiringRequestDto?.yearsOfExperience ?? 0,
    yearsOfRelevantExperience:
      hiringRequest.hiringRequestDto?.yearsOfRelevantExperience ?? 0,
    desiredStartDate: formatSingleDate(
      hiringRequest.hiringRequestDto?.desiredStartDate ?? '',
      yearDateFormat.date,
    ),
    additionalComments:
      hiringRequest.hiringRequestDto?.additionalComments ?? '',
    jobDescription: hiringRequest.hiringRequestDto?.jobDescription ?? '',
    jobDescriptionPath:
      hiringRequest.hiringRequestDto?.jobDescriptionPath ?? '',
    location: hiringRequest.hiringRequestDto?.location ?? '',
    isPriority: hiringRequest.hiringRequestDto?.isPriority ?? '',
    employeeId: hiringRequest.hiringRequestDto?.employeeId ?? null,
    status: hiringRequest.hiringRequestDto?.status ?? '',
    vendorName: Array.isArray(hiringRequest.hiringVendorDtoList)
      ? hiringRequest.hiringVendorDtoList?.map((vendor: any) => vendor.vendorName)?.join(', ')
      : '',
    jobTitle: hiringRequest.hiringRequestDto?.jobTitle ?? '',
    lobName: hiringRequest.hiringRequestDto?.lobName ?? '',
    noOfCandidates: hiringRequest.hiringRequestDto?.noOfCandidates ?? 0,
    ageOld: hiringRequest.ageOld ?? 0,
    createdDate: formatSingleDate(
      hiringRequest.hiringRequestDto?.createdDate ?? '',
      yearDateFormat.date,
    ),
    dntLeaderName: hiringRequest.hiringRequestDto?.dntLeaderName ?? '',
    projectName: hiringRequest.hiringRequestDto?.projectName ?? '',
    hiringManagerName: hiringRequest.hiringRequestDto?.hiringManagerName ?? '',
    skillName: Array.isArray(hiringRequest.skillName)
      ? hiringRequest.skillName
      : typeof hiringRequest.skillName === 'string' && hiringRequest.skillName
        ? [hiringRequest.skillName]
        : Array.isArray(hiringRequest.hiringRequestDto?.skillName)
          ? hiringRequest.hiringRequestDto.skillName
          : typeof hiringRequest.hiringRequestDto?.skillName === 'string' &&
              hiringRequest.hiringRequestDto.skillName
            ? [hiringRequest.hiringRequestDto.skillName]
            : [],
    panel1: panelName(1),
    panel2: panelName(2),
    panel3: panelName(3),
  };
}
